<template>
  <KDialog
    :title="title"
    :loading="loading"
    :visible="visible"
    :actions="dialogActions"
    @click:add="save"
    @click:edit="save"
    @click:close="close"
  >
    <KForm ref="form">
      <v-container>
        <v-row>
          <!-- Nome do Cargo -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Nome do Tipo de Contato"
              :error-messages="errors.name"
              v-model="form.name"
              hint="Digite o nome do tipo de contato"
              persistent-hint
              required
              @input="onChangeName"
            ></v-text-field>
          </v-col>

          <!-- Slug -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Slug"
              :error-messages="errors.slug"
              hint="Digite o Slug"
              persistent-hint
              v-model="form.slug"
              required
            ></v-text-field>
          </v-col>

          <!-- Nome do Ícone -->
          <v-col cols="12" sm="12" md="6">
            <KInputIcon
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Nome do Ícone"
              hint="Disponível em materialdesignicons.com"
              persistent-hint
              :error-messages="errors.icon"
              v-model="form.icon"
              required
            ></KInputIcon>
          </v-col>

          <!-- Base URL -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Base URL"
              hint="URL de base para o link da rede. Ex.: https://facebook.com/"
              persistent-hint
              :error-messages="errors.base_url"
              v-model="form.base_url"
              required
            ></v-text-field>
          </v-col>

          <!-- Texto de Placeholder -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Texto de Placeholder"
              hint="Texto que ficará dentro do campo como exemplo do preenchimento"
              persistent-hint
              :error-messages="errors.placeholder"
              v-model="form.placeholder"
              required
            ></v-text-field>
          </v-col>

          <!-- Dica do campo -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              dense
              outlined
              :rules="[$validation.isRequired]"
              label="Dica do campo"
              hint="Dica existente abaixo do campo para orientar o preenchimento"
              persistent-hint
              :error-messages="errors.hint"
              v-model="form.hint"
              required
            ></v-text-field>
          </v-col>

          <!-- Regra de validação -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              dense
              label="Regra de validação"
              hint="Regra que será usada na validação do campo. A regra 'custom' precisará ser declarada manualmente no código do cadastro da rede social"
              persistent-hint
              :error-messages="errors.rule"
              v-model="form.rule"
              required
            ></v-text-field>
          </v-col>
          <!-- Máscara -->
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              dense
              label="Máscara"
              hint="Máscara usada para ajudar o preenchimento"
              persistent-hint
              :error-messages="errors.mask"
              v-model="form.mask"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </KForm>
  </KDialog>
</template>

<script>
import KForm from "@/components/KForm";
import KDialog from "@/components/KDialog";
import KInputIcon from "@/components/KInput/Icon";
import { slug } from "klawtil";

export default {
  components: {
    KForm,
    KDialog,
    KInputIcon
  },

  data() {
    return {
      // Armazena os dados que virão via função para preencher
      form: {},
      editing: false,
      errors: {},

      visible: false,
      title: null,
      loading: false

      //
    };
  },

  computed: {
    dialogActions() {
      if (this.editing) {
        return [
          {
            eventName: "click:edit",
            label: "Salvar Alterações"
          }
        ];
      } else {
        return [
          {
            eventName: "click:add",
            label: "Cadastrar"
          }
        ];
      }
    }
  },

  methods: {
    /*******************************************************
     *
     *  FUNÇÕES PARA SALVAR E EDITAR OS DADOS NO STORE
     *
     *******************************************************/

    /**
     * Salva os dados no Store
     */
    async save() {
      try {
        //
        this.errors = {};
        // Se as demais validações passaram
        if (this.$refs["form"].validate()) {
          this.loading = true;
          //
          await this.$store.dispatch("contact_types/save", {
            payload: this.form,
            editing: this.editing
          });

          this.loading = false;
          this.$message.success("Registro salvo com sucesso");
          this.close();
        } else {
          this.$message.error("Verifique os campos marcados em vermelho");

          this.loading = false;
        }
      } catch (error) {
        this.errors = this.$message.serverError(error);
        this.loading = false;
      }
    },

    onChangeName() {
      if (!this.form.id && this.form.name) {
        this.form.slug = slug(this.form.name);
      }
    },

    /*******************************************************
     *
     *  FUNÇÕES BÁSICAS DE QUALQUER DIALOG
     *
     *******************************************************/

    /**
     * Abre o dialog preparado para cadastrar um novo dado
     */
    openToAdd() {
      // Altera o título
      this.title = "Cadastrar Nova Rede Social";

      // Limpa os dados
      this.clear();

      // Define se é uma edição
      this.editing = false;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog preparado para alteerar os dados
     */
    openToEdit(payload) {
      // Altera o título
      this.title = `Editar "${payload.name}"`;

      // Mescla os dados recebidos para não alterar o que está para trás
      this.form = { ...payload };

      // Define se é uma edição
      this.editing = true;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog
     */
    open() {
      this.visible = true;
    },

    /**
     * Fecha o dialog
     */
    close() {
      this.$refs.form.resetValidation();
      this.visible = false;
      this.clear();
    },

    /**
     * Limpa os dados do dialog
     */
    clear() {
      this.form = {};
    }
  }
};
</script>

<style>
</style>
